import { ADD_SINDROME_ANALISIS, DELETE_SINDROME_ANALISIS } from "./types";

const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ADD_SINDROME_ANALISIS:
      return [...state, action.payload];
    case DELETE_SINDROME_ANALISIS:
      return state.filter((element) => element !== action.payload);
    default:
      return state;
  }
};
